import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import EditCellActions from "./EditCellActions";
import EditCellHeader from "./EditCellHeader";
import EmptyTimeWindow from "./EmptyTimeWindow";
import TimeWindowRow from "./TimeWindowRow";

export default function ProviderHoursEditCell({
  day,
  index,
  timings,
  onChange,
  onAdd,
  onDelete,
  onSave,
  onDone,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="flex flex-col gap-3">
        <EditCellHeader day={day} index={index} onAdd={onAdd}/>

        {!timings || timings.length === 0 ? (
          <EmptyTimeWindow />
        ) : (
          timings.map((time, tIndex) => (
            <TimeWindowRow
              key={tIndex}
              index={index}
              timingIndex={tIndex}
              time={time}
              onChange={onChange}
              onSave={onSave}
              onDelete={onDelete}
            />
          ))
        )}

        <EditCellActions
          index={index}
          onSave={onSave}
          onDone={onDone}
        />
      </div>
    </LocalizationProvider>
  );
}
